module.exports = __webpack_public_path__ + "static/img/78118C_2_3_R_20181204_LC.6ab4aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/78118C_2_3_R_20181204_LC.png
// module id = a0m5
// module chunks = 0